import { render } from "./404.vue?vue&type=template&id=4ae76b48&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=4ae76b48&scoped=true&lang=css"

import exportComponent from "C:\\Users\\info\\Documents\\ownersite.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae76b48"]])

export default __exports__